import { Component, OnInit, Input } from '@angular/core';
import { environment} from '../../../../environments/environment'

@Component({
  selector: 'app-img-envio',
  templateUrl: './img-envio.component.html',
  styleUrls: ['./img-envio.component.css']
})
export class ImgEnvioComponent implements OnInit {
  imagen : any = "";
  @Input() public color ;
  constructor() { }

  ngOnInit() {
    let iconoVerServicio  = environment.MENU_VER_SERVICIOS.VISUALIZAR_ICONO
    Object.keys(iconoVerServicio).forEach((key)=> {
      console.log(key, iconoVerServicio[key]);
      if(iconoVerServicio[key])
        this.imagen =  key;
    });
    // if(environment.ICONS.MOTO == true){
    //   this.imagen = true;
    // }else{
    //   this.imagen = false;
    // }

  }

}
